<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container"></div>
    </div>
    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">
          {{ $t("portus.dynamic") }}
          <div class="dynamicFont">
            {{ $t("portus.dynamic_") }}
          </div>
        </div>

        <div class="pd100">
          <img :src="$t('picture.dynamic')" alt="" />
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f9f9f9">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("portus.dashboard") }}</div>
        <el-carousel indicator-position="outside" arrow="never">
          <el-carousel-item
            v-for="item in swiperList"
            :key="item"
            style="text-align: center"
          >
            <img :src="item" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("solution.integrated") }}</div>
        <div class="integrated_marketing">
          <div class="offerFont">
            {{ $t("portus.offer") }}
          </div>
          <div class="marketing_service">
            <div class="marketing_provide">
              <div class="marketing1 mr20">
                <img src="../../../public/static/img/portus/ying.png" alt="" />
              </div>

              <div>
                <div>{{ $t("portus.marketing1") }}</div>
                <div>{{ $t("portus.marketing2") }}</div>
              </div>
            </div>
            <div class="marketing_provide">
              <div class="marketing2 mr20">
                <img src="../../../public/static/img/portus/fu.png" alt="" />
              </div>
              <div>
                <div>{{ $t("portus.content1") }}</div>
                <div>{{ $t("portus.content2") }}</div>
              </div>
            </div>
            <div class="marketing_provide">
              <div class="marketing3 mr20">
                <img src="../../../public/static/img/portus/zhi.png" alt="" />
              </div>
              <div>
                <div>{{ $t("portus.live1") }}</div>
                <div>{{ $t("portus.live2") }}</div>
              </div>
            </div>
            <div class="marketing_provide">
              <div class="marketing4 mr20">
                <img src="../../../public/static/img/portus/shu.png" alt="" />
              </div>
              <div>
                <div>{{ $t("portus.data1") }}</div>
                <div>{{ $t("portus.data2") }}</div>
              </div>
            </div>
            <div class="marketing_provide">
              <div class="marketing5 mr20">
                <img src="../../../public/static/img/portus/union.png" alt="" />
              </div>
              <div>
                <div>{{ $t("portus.joint1") }}</div>
                <div>{{ $t("portus.joint2") }}</div>
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: center; position: relative">
          <div class="marketing_widthHeight">
            <img src="../../../public/static/img/portus/marketing.png" alt="" />
          </div>
          <div class="operateFont">
            {{ $t("portus.operate") }}
          </div>
          <div class="popUpFont">
            {{ $t("portus.popUp") }}
          </div>
          <div class="onlineFont">
            {{ $t("portus.online") }}
          </div>
          <div class="outputFont">
            <div style="width: 153px">{{ $t("portus.output") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      swiperList: [
        'http://travelmall.portus.cn/2023/04/cca313190ad8478ea16a7f92555f1eab.png',
        'http://travelmall.portus.cn/2023/04/2aa672e952df47a88d615d804b69fe2a.png',
        'http://travelmall.portus.cn/2023/04/d7b5fa4a7e1d43ac9ef5edfa1f233d5b.png',
        'http://travelmall.portus.cn/2023/04/58c9339e749840a6b12f6b54ae1f176a.png'
      ]
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .el-carousel__container {
  height: 478px;
}
/deep/ .el-carousel__button {
  width: 60px;
  background-color: #f9c01d;
}
/deep/ .el-carousel__indicators--outside {
  margin-top: 66px;
}
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  background-image: url("http://travelmall.portus.cn/2023/04/ca55ac69cf3e4a75be669cd828e1b382.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>
